import { useAuth } from "@/context/AuthContext";

export default function AccountProfile() {
  const { user } = useAuth();
  const Row = ({ label, value }) => (
    <div className="grid grid-cols-[160px_1fr] gap-4 py-3 border-b border-[var(--line)] last:border-b-0">
      <dt className="font-mono text-[10.5px] tracking-[0.18em] uppercase text-[var(--ink-muted)]">{label}</dt>
      <dd className="text-sm font-mono">{value || "—"}</dd>
    </div>
  );
  return (
    <div data-testid="account-profile">
      <div className="border border-[var(--line)] rounded-md p-6 bg-[var(--paper-2)]">
        <Row label="Name" value={user?.name} />
        <Row label="Email" value={user?.email} />
        <Row label="Organization" value={user?.organization} />
        <Row label="Buyer type" value={user?.buyer_type} />
        <Row label="Role" value={user?.role} />
        <Row label="Status" value={user?.qualified ? "Qualified researcher" : "Pending qualification"} />
      </div>
      <p className="text-xs text-[var(--ink-muted)] mt-4 leading-relaxed">
        Use the sidebar to manage your saved shipping addresses, view past orders, and submit COAs for batches you've independently tested.
      </p>
    </div>
  );
}
